// uses ./mobileFilters/mobileFilters.less
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../common/Icon';

function mobileFilters(props) {
    return (
        <div className="mobileFilters">
            <h4 className="mobileFilters-toggle" onClick={props.dispatchToggleFilters}>
                <span>
                    {' '}
                    <Icon alias="tune" /> Filters
                </span>
            </h4>
            {/* <a
                className="appsListFiltersNavbar-clear"
                onClick={props.dispatchResetFilters}
            >
                 Clear
            </a> */}
        </div>
    );
}

mobileFilters.propTypes = {
    dispatchToggleFilters: PropTypes.func,
    dispatchResetFilters: PropTypes.func,
};

export default mobileFilters;
